<template>
  <div class="publishing-schedules settings-templates">
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar
        title="Publishing Schedules"
        @search="updateSearchValue"
        hideSearchBar
      />
      <div v-if="isFetchingScheduleTemplates">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="publishingScheduleTemplate in publishingScheduleTemplates"
          :key="publishingScheduleTemplate.id"
          @click="canEdit && handleSelect(publishingScheduleTemplate)"
        >
          <PublishingScheduleItem
            :publishingScheduleTemplate="publishingScheduleTemplate"
          />
        </v-list-item>
      </div>
    </div>
    <BaseFooter>
      <Permissioned section="settings">
        <NewPublishingScheduleAction permission="publishing-schedules.edit" />
      </Permissioned>
    </BaseFooter>
    <EditPublishingScheduleDialog
      v-if="isOpen"
      :publishingScheduleTemplate="currentPublishingSchedule"
      @close="isOpen = false"
      :isOpen="isOpen"
      isUpdate
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { size } from "lodash";
import { FETCH_PUBLISHING_SCHEDULE_TEMPLATES } from "@/store/modules/organisations/organisation-schedules/actions";
import { ORGANISATION_SCHEDULES_NAMESPACE } from "@/store/modules/organisations/organisation-schedules";
import PublishingScheduleItem from "@/views/settings/components/publishing-schedule-templates/components/PublishingScheduleItem";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import NewPublishingScheduleAction from "@/views/settings/components/publishing-schedule-templates/components/actions/NewPublishingScheduleAction";
import BaseFooter from "@/components/common/BaseFooter";
import EditPublishingScheduleDialog from "@/views/settings/components/publishing-schedule-templates/components/dialogs/PublishingScheduleDialog";
import Permissioned from "@/components/common/Permissioned";
import { isPermissioned } from "@/utils/permissions";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_SCHEDULES_NAMESPACE
);

export default {
  components: {
    PublishingScheduleItem,
    BaseListToolbar,
    NewPublishingScheduleAction,
    BaseFooter,
    EditPublishingScheduleDialog,
    Permissioned
  },
  data() {
    return {
      searchText: "",
      currentPublishingSchedule: {},
      isOpen: false
    };
  },
  created() {
    this.loadTemplates();
  },
  computed: {
    ...mapState(
      copyState(["publishingScheduleTemplates", "isFetchingScheduleTemplates"])
    ),
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { search: this.searchText })
        }
      };
    },
    canEdit() {
      return isPermissioned("settings.publishing-schedules.edit");
    }
  },
  methods: {
    ...mapActions({
      fetchSchedules: FETCH_PUBLISHING_SCHEDULE_TEMPLATES
    }),
    handleSelect(template) {
      this.currentPublishingSchedule = template;
      this.isOpen = true;
    },
    async loadTemplates() {
      await this.fetchSchedules(this.requestParams);
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.loadTemplates();
    }
  }
};
</script>

<style lang="scss">
.publishing-schedules {
  .list-item .v-avatar.v-list-item__avatar {
    background-color: rgb(99 99 99 / 10%);
  }
}
</style>
